import request from '@/utils/request'
let DistributionApi = {
    /*发货单列表*/
    orderlist(data, errorback) {
        return request._post('/shop/plus.distribution.order/index', data, errorback);
    },
    /*发货单详情*/
    orderDetail(data, errorback) {
        return request._post('/shop/plus.distribution.order/detail', data, errorback);
    },
    /*发货单详情*/
    pickOrderDetail(data, errorback) {
        return request._post('/shop/plus.distribution.picking/detail', data, errorback);
    },
    /*添加发货单*/
    addOrder(data, errorback) {
        return request._post('/shop/plus.distribution.order/add', data, errorback);
    },
    /*拣货单列表*/
    pickingOrderList(data, errorback) {
        return request._post('/shop/plus.distribution.picking/index', data, errorback);
    },
    /*拣货单列表*/
    pickingOrderAdd(data, errorback) {
        return request._post('/shop/plus.distribution.picking/pickingOrderAdd', data, errorback);
    },
    /*添加员工*/
    userAdd(data, errorback) {
        return request._post('/shop/plus.distribution.user/userAdd', data, errorback);
    },
    /*员工列表*/
    userList(data, errorback) {
        return request._post('/shop/plus.distribution.user/index', data, errorback);
    },
    /*编辑员工*/
    userEdit(data, errorback) {
        return request._post('/shop/plus.distribution.user/edit', data, errorback);
    },
    /*删除员工*/
    userDelete(data, errorback) {
        return request._post('/shop/plus.distribution.user/delete', data, errorback);
    },

}

export default DistributionApi;



// WEBPACK FOOTER //
// ./src/api/distribution.js